import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';

export function* getTeacherAuthToken({ userProfileType, userProfileId }) {
    const response = yield call(api.getTeacherAuthToken, userProfileType, userProfileId);
    if (response.status === 200) {
        yield put(actions.getTeacherAuthTokenSuccess(response.data));
    } else {
        yield put(actions.getTeacherAuthTokenFailure());
    }
}

export function* getTeacherAuthTokenRequestSaga() {
    yield takeLatest(actions.GET_TEACHER_AUTH_TOKEN_REQUEST, getTeacherAuthToken);
}



// WEBPACK FOOTER //
// ./app/containers/teacher-view/saga.js